import { useMemo } from 'react';

import { ComponentDecorator, CompositeComponent } from 'formik';

export const useGetForm = <TReturnedProps, TWrappedProps>(
  wrapperFunc: ComponentDecorator<TReturnedProps, TWrappedProps>,
  Component: CompositeComponent<TWrappedProps>,
  deps?: unknown
) => {
  return useMemo(() => wrapperFunc(Component), [deps]);
};
